module.exports = __webpack_public_path__ + "static/images/default-cover.e2ab1d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/default-cover.png
// module id = 1231
// module chunks = 0